var userAgent = require('../internals/engine-user-agent');

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-webkit-version.js
// module id = 1082
// module chunks = 0